import React, { useState, useEffect } from 'react'
import { Select, Spin, Table, Tooltip } from 'antd'
import axios from 'axios'
import { useLocation } from 'react-router-dom'


const PositionFuture = (props) => {
  const { username, option, newOption, selectedOptionData } = props?.data
  const [CheckBal, setCheckBal] = useState([]);
  const [historyData, setHistoryData] = useState([])
  const [futureData, setFutureData] = useState([])
  const [loading, setLoading] = useState(false);
  const [option2, setOption2] = useState(option)
  const [Api, setApi] = useState("option[0]?.label")
  const { type, apiKey, apiSecret, selectedapi } = props?.data;
  const location = useLocation();

  useEffect(() => {
    setFutureData([])
    setOption2(option)
    const fisrtLabel = "option[0]?.label"
    setApi(fisrtLabel)
  }, [option])

  const checkSpotBalance = async () => {
    setCheckBal(null);
    setLoading(true);
    const token = localStorage.getItem("jwt");


    try {

      // Accumulate all responses in an array
      const allOrders = [];
      const secondApiData = {
        request_type: "private",
        method: "GET",
        key: apiKey,
        secret: apiSecret,
        endpoint: "/fapi/v2/positionRisk",

      };

      const secondRes = await axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: process.env.REACT_APP_API_ALLCOINSF + "/make_request",
        data: secondApiData,
      });

      allOrders.push(...secondRes.data.Success);


      const formattedData = allOrders
        .filter(order => order.orderId !== 0 && order.entryPrice !== "0.0")  // Filter out orders with orderId 0 and entryPrice "0.0"
        .map(order => ({
          time: new Date(order.time),
          orderId: order.orderId,
          symbol: order.symbol,
          type: order.type,
          side: order.side,
          avgPrice: order.avgPrice,
          price: order.price,
          leverage: order.leverage,
          notional: order.notional,
          origQty: order.origQty,
          positionSide: order.positionSide,
          status: order.status,
          executedQty: order.executedQty,
          entryPrice: order.entryPrice,
          markPrice: order.markPrice,
          unRealizedProfit: order.unRealizedProfit,
          positionAmt: order.positionAmt,
          liquidationPrice: order.liquidationPrice,
          breakEvenPrice: order.breakEvenPrice
        }));


      setHistoryData(formattedData);
      setLoading(false);

    } catch (err) {
      setLoading(false);
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    if (selectedapi) {
      checkSpotBalance();
    }
  }, [selectedapi]);


  const dataSource = historyData?.length > 0
    ? historyData.map((data) => ({
      symbol: <div className='flex gap-2 items-center'>
        <p className={`p-1 rounded-lg border-l-4 ${data?.positionSide === "SHORT" ? "border-red-500" : "border-[green]"} flex`}>{data?.symbol}</p>

        <span className="text-[#69681d] ">
          {data?.leverage + "x" || 0}
        </span>
      </div>,
      entryPrice: <p className="p-1 rounded-lg">{data?.entryPrice}</p>,
      breakEvenPrice: <p className="p-1 rounded-lg">{data?.breakEvenPrice}</p>,
      leverage: <p className="p-1 rounded-lg">{data?.leverage}</p>,
      markPrice: <p className="p-1 rounded-lg">{data?.markPrice}</p>,
      unRealizedProfit: (
        <p className={`p-1 rounded-lg ${data?.unRealizedProfit > 0 ? "text-green-500" : "text-red-900"}`}>
          {data?.unRealizedProfit}
        </p>
      ),
      liquidationPrice: <p className="p-1 rounded-lg">{data?.liquidationPrice}</p>,
      Margin_Type: <p className="p-1 rounded-lg">{data?.Margin_Type}</p>,
      positionSide: (
        <p className={`p-1 rounded-lg ${data?.positionSide === "LONG" ? "text-green-500" : "text-red-500"}`}>
          {data?.positionSide}
        </p>
      ),
      notional: (
        <p className={`p-1 rounded-lg ${parseFloat(data?.notional) > 0 ? "text-green-500" : "text-red-900"}`}>
          {data?.notional && !isNaN(parseFloat(data.notional))
            ? `${parseFloat(data.notional).toFixed(4)} USDT`
            : "--"}
        </p>
      ),

      Update_Time: <p className="p-1 rounded-lg">{data?.Update_Time}</p>,
      positionAmt: (
        <p className={`p-1 rounded-lg ${data?.positionAmt > 0 ? "text-green-500" : "text-red-900"}`}>
          {data?.positionAmt}
        </p>
      ),
    }))
    : [
      {
        symbol: <p className="p-1 rounded-lg border-l-4 flex">*****</p>,
        entryPrice: <p className="p-1 rounded-lg">*****</p>,
        markPrice: <p className="p-1 rounded-lg">*****</p>,
        unRealizedProfit: <p className="p-1 rounded-lg ">*****</p>,
        liquidationPrice: <p className="p-1 rounded-lg">*****</p>,
        Leverage: <p className="p-1 rounded-lg">*****</p>,
        Margin_Type: <p className="p-1 rounded-lg">*****</p>,
        positionSide: <p className="p-1 rounded-lg ">*****</p>,
        notional: <p className="p-1 rounded-lg ">*****</p>,
        Update_Time: <p className="p-1 rounded-lg">*****</p>,
        positionAmt: <p className="p-1 rounded-lg ">*****</p>,
        breakEvenPrice: <p className="p-1 rounded-lg ">*****</p>,
      },
    ];

  if (historyData?.length === 0 && location.pathname === "/dashboard/position") {
    return <p className="p-1 rounded-lg text-center my-2 bg-white">No Open Position Data Avaliable</p>;
  }

  const columns = [
    // {
    //   title: <p className='p-1 text-center '>Update Time</p>,
    //   dataIndex: 'Update_Time',
    //   key: 'Update_Time',
    //   width : 200
    // },
    {
      title: <p className='p-1 text-center '>Symbol</p>,
      dataIndex: 'symbol',
      key: 'Symbol',
    },
    {
      title: <Tooltip title="" placement="top"><p className='p-1 text-center '>Size</p></Tooltip>,
      dataIndex: 'notional',
      key: 'notional',
    },

    {
      title: <p className='p-1 text-center '>Entry Price</p>,
      dataIndex: 'entryPrice',
      key: 'Entry_Price',
    },


    {
      title: <p className='p-1 text-center '>Break Even Price</p>,
      dataIndex: 'breakEvenPrice',
      key: 'breakEvenPrice',
    },
    {
      title: <p className='p-1 text-center '>Mark Price</p>,
      dataIndex: 'markPrice',
      key: 'Mark_Price',
    },
    {
      title: <p className='p-1 text-center '>Liq.price</p>,
      dataIndex: 'liquidationPrice',
      key: 'Liquidation_Price',
    },
    // {
    //   title: <p className='p-1 text-center '>Leverage</p>,
    //   dataIndex: 'Leverage',
    //   key: 'Leverage',
    // },
    // {
    //   title: <p className='p-1 text-center '>MarginType</p>,
    //   dataIndex: 'Margin_Type',
    //   key: 'Margin_Type',
    // },
    {
      title: <Tooltip title="Position Side" placement="top"><p className='p-1 text-center '>PS</p></Tooltip>,
      dataIndex: 'positionSide',
      key: 'Position_Side',
    },
    {
      title: <Tooltip title="Position Amount" placement="top"><p className='p-1 text-center '>PA</p></Tooltip>,
      dataIndex: 'positionAmt',
      key: 'PosiAmoun',
    },

    {
      title: <p className='p-1 text-center '>PNL(ROI%)</p>,
      dataIndex: 'unRealizedProfit',
      key: 'Unrealized_Profit',
    },
  ]


  const handleChange = (value) => {
    setApi(value)
  }

  return (
    <div>

      <div className=' mt-4  '>
        <Spin spinning={loading} >
          <Table columns={columns} dataSource={dataSource} scroll={{
            x: 1500,
          }} />
        </Spin>
      </div>
    </div>
  )
}

export default PositionFuture
